import { Badge } from "@/shared/ui/badge";
import { Card, CardContent } from "@/shared/ui/card";

import type { GeoReport } from "../../../api/geoService";

/** 负面曝光卡:疑虑类回答中出现负面口径的比例 + 原话样本。 */
export function NegativeExposure({ report }: { report: GeoReport }) {
  const rate = report.negative_exposure?.rate;
  const samples = report.negative_exposure?.samples ?? [];
  if (rate == null) return null;
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-sm font-medium">负面曝光</div>
        <div className="mt-1 text-xs text-muted-foreground">疑虑类回答中出现负面口径的比例</div>
        <div
          className={`mt-2 text-3xl font-bold tabular-nums ${
            rate > 0 ? "text-rose-500" : "text-emerald-500"
          }`}
        >
          {rate}%
        </div>
        {samples.slice(0, 2).map((s, i) => (
          <div
            key={i}
            className="mt-2 rounded border-l-2 border-rose-500 bg-muted/40 px-3 py-2 text-xs text-muted-foreground"
          >
            “{s}”
          </div>
        ))}
        {rate === 0 && <div className="mt-2 text-xs text-muted-foreground">本轮未发现负面口径</div>}
      </CardContent>
    </Card>
  );
}

/** 品牌画像卡:AI 现在给你贴的标签 vs 你想建立的印象 —— 差距即内容方向。 */
export function BrandPortrait({ report }: { report: GeoReport }) {
  const labels = report.brand_portrait?.labels ?? [];
  const wanted = report.brand_portrait?.wanted ?? [];
  if (labels.length === 0 && wanted.length === 0) return null;
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-sm font-medium">AI 眼中的品牌画像</div>
        <div className="mt-1 text-xs text-muted-foreground">
          现有印象 vs 想建立的印象,差距就是内容方向
        </div>
        {labels.length > 0 && (
          <div className="mt-3">
            <div className="text-xs text-muted-foreground">AI 现在的印象</div>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              {labels.map((l) => (
                <Badge key={l} variant="secondary" className="font-normal">
                  {l}
                </Badge>
              ))}
            </div>
          </div>
        )}
        {wanted.length > 0 && (
          <div className="mt-3">
            <div className="text-xs text-muted-foreground">你想建立的印象</div>
            <div className="mt-1.5 flex flex-wrap gap-1.5">
              {wanted.map((l) => (
                <Badge
                  key={l}
                  variant="outline"
                  className="border-amber-500/60 font-normal text-amber-500"
                >
                  {l}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
